import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title',
		defaultMessage: 'Site optimizer',
		description: 'Title of the "Site optimizer" submenu under troubleshooting and support.',
	},
	overview: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview',
		defaultMessage: 'Overview',
		description:
			'Menu item for the overview page for site optimizer under troubleshooting and support.',
	},
	allReports: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports',
		defaultMessage: 'All reports',
		description:
			'Menu item for the all metrics that we are reporting for site optimizer under troubleshooting and support.',
	},
	dashboard: {
		id: 'spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.dashboard',
		defaultMessage: 'Dashboard',
		description:
			'Menu item for the dashboard page for site optimizer under troubleshooting and support.',
	},
});
